import React from 'react'
import { GxIcon } from '@garpix/garpix-web-components-react'
import Title from '../Title'
import { usePage } from '@/hooks'
import { removeHttp } from '@/utils'
import { educationIcon, locationIcon, webIcon } from '@/images'
import style from './styles/institutions.module.scss'

interface IProps {
  city: string
  id: number
  logo: string | null
  site: string
  title: string
}

const InstitutionsCard = ({
  city,
  id,
  logo,
  site,
  title
}: IProps): React.ReactElement => {
  const siteHostname = removeHttp(site)
  const page = usePage()
  const { config } = page?.init_state?.global
  return (
    <div className={style.inst}>
      <a
        href={`${config.institution_detail}?element_id=${id}`}
        className={style.inst__link}
      />
      {logo === null
        ? (
          <div className={style.inst__empty}>
            <GxIcon src={educationIcon} className={style.inst__empty_icon} />
          </div>
          )
        : (
          <img
            src={logo}
            width='145px'
            height='233px'
            alt={title}
            className={style.inst__logo}
          />
          )}
      <Title type='h3' theme='h4' className={style.inst__title}>
        {title}
      </Title>

      <div className={style.inst_wrap}>
        {city !== ''
          ? (
            <span className={style.inst__city}>
              <GxIcon src={locationIcon} className={style.inst__icon} />
              {city}
            </span>
            )
          : null}
        {siteHostname !== ''
          ? (
            <a
              href={site}
              target='_blank'
              rel='nofollow noopener noreferrer'
              className={style.inst__site}
            >
              <GxIcon src={webIcon} className={style.inst__icon} />
              {siteHostname}
            </a>
            )
          : null}
      </div>
    </div>
  )
}

export default InstitutionsCard
